export default "__VITE_ASSET__BzBj1iSA__"